import configuration from "../config";

export const getAccessRights = async () => {
  const data = await configuration.getAPI({ url: 'common/list-access', params: { roleID : localStorage.getItem("role_id") } })
  let modules = data?.payload?.map((access) => {
    return {
      module: access?.title,
      code: access?.code,
      view: access?.data?.is_view,
      add: access?.data?.is_add,
      edit: access?.data?.is_edit,
      delete: access?.data?.is_delete,
    };
  });

  return modules;
};
